import channels from "../enum/channels";
import {
  getBenefitStatus,
  getBenefitStatusFromRechargeService,
  createCheckoutCoreSession as requestCheckoutCoreSession,
  getCheckoutUrlV2,
  getRecurrenceStatus,
} from "../api/smartcheckout";
import { getSessionLoopId } from "./loopEvents";

const getSmartcheckoutUrlV2 = async (msisdn, channel, recipient, productId, origin, tags) => {
  const response = await getCheckoutUrlV2(msisdn, {
    msisdn,
    channel,
    recipient,
    productId,
    origin,
    sessionLoopId: getSessionLoopId(),
    ...(tags && Object.keys(tags).length > 0 && { tags }),
  });

  return response;
};

const createCheckoutCoreSession = async ({
  msisdn,
  channel,
  recipient,
  offerId,
  ipAddress,
  tags,
}) => {
  const response = await requestCheckoutCoreSession(msisdn, {
    channel,
    payer: msisdn,
    recipient: recipient || msisdn,
    // O checkout-core do CLARO_YOUTUBE exige offer_id como string; os demais canais
    // seguem enviando o tipo original devolvido pela digisession.
    offer_id: channel === channels.claro_youtube ? String(offerId) : offerId,
    ...(ipAddress && { ip_address: ipAddress }),
    ...(tags && Object.keys(tags).length > 0 && { tags }),
  });

  return response;
};

const getSmartcheckoutBenefitStatus = async (identifier, correlationId) => {
  return getBenefitStatus(identifier, correlationId);
};

// Fluxo novo, dos canais que obtem o callback pelo recharge-service. Separado de proposito:
// o caminho do becrux acima nao muda, e some inteiro quando o legado morrer.
const getSmartcheckoutBenefitStatusFromRechargeService = async (identifier, correlationId) => {
  return getBenefitStatusFromRechargeService(identifier, correlationId);
};

const getSmartcheckoutRecurrenceStatus = async (identifier, correlationId) => {
  return getRecurrenceStatus(identifier, correlationId);
};

export {
  getSmartcheckoutUrlV2,
  getSmartcheckoutBenefitStatus,
  getSmartcheckoutBenefitStatusFromRechargeService,
  createCheckoutCoreSession,
  getSmartcheckoutRecurrenceStatus,
};
